import React from 'react';
import {withStore} from "../../hocs";
import {observer} from "mobx-react";
import {EnumUserType} from "../../enum/EnumUserType";
import {BreadCrumbs} from "../../components/tpl/BreadCrumbs";
import {RedirectUrl} from "../../components/RedirectUrl";
import {AdminAuth} from "../../components/user/AdminAuth";
import {adminPanelUrl} from "../../constants/adminPanelPath";


// @ts-ignore
@withStore
@observer
export class AdminAuthPage extends React.Component {

    componentDidMount() {
        // @ts-ignore
        const {store} = this.props;
        store?.pageAdminAuthStore.init();
        store.basePageStore.setBreadCrumbs([{name: 'Администрирование', url: adminPanelUrl()},{name: 'Авторизация под пользователями', url: adminPanelUrl('auth')}]).setTitleInBreadCrumbs();
        store?.componentTopSearchStore.clearSearch();
    }

    render() {
        // @ts-ignore
        const {store} = this.props;
        const {
            arUsers,
        } = store?.pageAdminAuthStore;
        const {
            onFilterUser,
            search
        } = store?.pageAdminAuthStore;
        let type = store.mainStore.getUserType();
        const {onLoginRoot} = store?.authStore;
        let arItemsV = [];
        if (search.length > 2) {
            arItemsV = arUsers.filter((item: any) => item.search.includes(search?.toUpperCase()));
        } else {
            arItemsV = arUsers;
        }
        return (
            <>
                <RedirectUrl/>
                <div className="container">
                    <div className="breadcrumbs">
                        <div className="breadcrumbs-wrapper">
                            <BreadCrumbs/>
                        </div>
                    </div>
                    <div className="catalog-title">
                        <h1 className="catalog-title__text">Авторизация под пользователями </h1>
                    </div>
                    {[EnumUserType.adminAuth, EnumUserType.root].includes(type) ?
                        <AdminAuth
                            onFilterUser={onFilterUser}
                            onLoginRoot={onLoginRoot}
                            arUsers={arItemsV}
                        />
                        : null}
                </div>
            </>
        )
    }
}